import { updates } from "@/mocks/comics";
import { SectionHeading } from "./HotComics";

const dayTabs = ["今日", "本周", "本月"];

export default function Updates() {
  return (
    <section className="mx-auto px-4 md:px-8 py-14 md:py-20">
      <SectionHeading
        anchor="updates"
        kicker="每日更新 · UPDATES"
        title="每日更新榜单，追更不迷路"
        desc="热门韩漫每日定时更新，最新章节抢先看。章节完整不等待，第一时间跟上热血的连载节奏。"
      />

      <div className="flex items-center gap-2 mb-6">
        {dayTabs.map((t) => (
          <button
            key={t}
            className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors cursor-pointer ${
              t === "今日"
                ? "bg-accent-500 text-background-950 font-semibold"
                : "text-foreground-400 hover:text-foreground-100"
            }`}
          >
            {t}更新
          </button>
        ))}
      </div>

      <div className="rounded-lg bg-background-900/70 border border-background-800/60 overflow-hidden">
        <div className="hidden md:grid grid-cols-12 gap-4 px-5 py-3 text-xs text-foreground-500 bg-background-800/60 border-b border-background-700/60">
          <span className="col-span-5">作品 / 最新话</span>
          <span className="col-span-3">分类</span>
          <span className="col-span-2">状态</span>
          <span className="col-span-2 text-right">更新时间</span>
        </div>
        {updates.map((u) => (
          <div
            key={u.id}
            className="grid grid-cols-12 items-center gap-3 px-4 md:px-5 py-3.5 border-b border-background-800/50 last:border-0 hover:bg-background-800/40 transition-colors"
          >
            <div className="col-span-12 md:col-span-5 flex items-center gap-3 min-w-0">
              {u.hot && (
                <span className="shrink-0 w-6 h-6 flex items-center justify-center rounded-md bg-accent-500/20 text-accent-400">
                  <i className="ri-fire-fill" />
                </span>
              )}
              <div className="min-w-0">
                <p className="text-sm font-semibold text-foreground-100 truncate">{u.title}</p>
                <p className="text-xs text-foreground-500 truncate">{u.episode}</p>
              </div>
            </div>
            <span className="col-span-6 md:col-span-3 text-sm text-foreground-400 truncate">{u.category}</span>
            <span className="col-span-3 md:col-span-2">
              <span className="text-xs rounded-md bg-primary-600/20 text-primary-300 px-2 py-0.5">已更新</span>
            </span>
            <span className="col-span-3 md:col-span-2 text-sm text-foreground-400 text-left md:text-right flex items-center gap-1">
              <i className="ri-time-line" />
              {u.time}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}